<app-tabla-general [displayedColumns]="displayedColumns" [moduloActual]="'usuarios'"></app-tabla-general>
<router-outlet></router-outlet>
